import { jsPDF } from 'jspdf';
import { autoTable } from 'jspdf-autotable';
import { getExportValue } from './ExportTableData';

/**
 * Reusable PDF exporter for ReportTable
 *
 * @param {Object} options
 * @param {Array} options.rows - Table rows
 * @param {Array} options.columns - DataGrid column definitions
 * @param {String} options.title - Report title
 * @param {String} options.fileName - Optional filename
 */
export const exportTableToPDF = ({
  rows = [],
  columns = [],
  title = 'Report',
  fileName,
  notes = [],
}) => {
  const doc = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format: 'letter',
  });

  // File name
  const defaultFileName =
    `${title.toLowerCase().replace(/\s+/g, '_')}_report.pdf`;

  const finalFileName =
    fileName?.trim()
      ? fileName.trim().endsWith('.pdf')
        ? fileName.trim()
        : `${fileName.trim()}.pdf`
      : defaultFileName;

  // Title
  doc.setFontSize(18);
  doc.text(title, 14, 15);

  // Date generated
  doc.setFontSize(10);
  doc.text(
    `Generated: ${new Date().toLocaleString()}`,
    14,
    22
  );

  // Include the requested period and comparison windows in dated exports.
  const noteLines = notes.flatMap(note => doc.splitTextToSize(String(note), 245));
  if (noteLines.length) doc.text(noteLines, 14, 28);
  const tableStart = 28 + (noteLines.length ? noteLines.length * 4 + 3 : 0);

  // Generate columns 
  const exportColumns = columns.filter(
    (column) => column.exportable !== false // add exportable:false to columns that don't need to be added into the export (EX: orders table, ticket viewer column is excluded from export because it's just blank if included)
  );
  // Generate headers
  const headers = exportColumns.map(
    (column) => column.headerName || column.field
  );
  // Generate table content
  const body = rows.map((row) =>
    exportColumns.map((column) => {
      const value = getExportValue(row, column);

      return value === null || value === undefined || value === ''
        ? '-'
        : String(value);
    })
  );

  // Create PDF table
  autoTable(doc, {
    startY: tableStart,

    head: [headers],

    body,

    theme: 'striped',

    styles: {
      fontSize: 8,
      cellPadding: 2,
    },

    headStyles: {
      fontSize: 8,
      fontStyle: 'bold',
    },

    margin: {
      top: 28,
      right: 10,
      bottom: 10,
      left: 10,
    },
  });

  doc.save(finalFileName);
};

